module.exports = __webpack_public_path__ + "img/logo.52ebf365.png";